import type { UnitCircleWidgetConfig } from '../unit-circle.model';

export { UNIT_CIRCLE_BASIC_PRESET } from './unit-circle-basic.preset';
export { UNIT_CIRCLE_TRIG_PRESET } from './unit-circle-trig.preset';
export { UNIT_CIRCLE_SPECIAL_ANGLES_PRESET } from './unit-circle-special-angles.preset';
export { UNIT_CIRCLE_SPECIAL_ANGLES_DEG_PRESET } from './unit-circle-special-angles-deg.preset';
export { UNIT_CIRCLE_AXIS_RADIANS_PRESET } from './unit-circle-axis-radians.preset';
export { UNIT_CIRCLE_FULL_PRESET } from './unit-circle-full.preset';
export { UNIT_CIRCLE_SIN_WAVE_TRACE_PRESET } from './sin-wave-trace.preset';
export { UNIT_CIRCLE_COS_WAVE_TRACE_PRESET } from './cos-wave-trace.preset';
export { UNIT_CIRCLE_TAN_WAVE_TRACE_PRESET } from './tan-wave-trace.preset';

import { UNIT_CIRCLE_BASIC_PRESET } from './unit-circle-basic.preset';
import { UNIT_CIRCLE_TRIG_PRESET } from './unit-circle-trig.preset';
import { UNIT_CIRCLE_SPECIAL_ANGLES_PRESET } from './unit-circle-special-angles.preset';
import { UNIT_CIRCLE_SPECIAL_ANGLES_DEG_PRESET } from './unit-circle-special-angles-deg.preset';
import { UNIT_CIRCLE_AXIS_RADIANS_PRESET } from './unit-circle-axis-radians.preset';
import { UNIT_CIRCLE_FULL_PRESET } from './unit-circle-full.preset';
import { UNIT_CIRCLE_SIN_WAVE_TRACE_PRESET } from './sin-wave-trace.preset';
import { UNIT_CIRCLE_COS_WAVE_TRACE_PRESET } from './cos-wave-trace.preset';
import { UNIT_CIRCLE_TAN_WAVE_TRACE_PRESET } from './tan-wave-trace.preset';

export const UNIT_CIRCLE_PRESETS: UnitCircleWidgetConfig[] = [
  UNIT_CIRCLE_BASIC_PRESET,
  UNIT_CIRCLE_AXIS_RADIANS_PRESET,
  UNIT_CIRCLE_SIN_WAVE_TRACE_PRESET,
  UNIT_CIRCLE_COS_WAVE_TRACE_PRESET,
  UNIT_CIRCLE_TAN_WAVE_TRACE_PRESET,
  UNIT_CIRCLE_SPECIAL_ANGLES_PRESET,
  UNIT_CIRCLE_SPECIAL_ANGLES_DEG_PRESET,
  UNIT_CIRCLE_FULL_PRESET,
  UNIT_CIRCLE_TRIG_PRESET,
];
